var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import moment from 'moment';
import RootType from '../../store/mutation-types';
import PurBackService from '../../api/PurBackService';
import DeliverService from '../../api/DeliverService';
import PurchaseService from '../../api/PurchaseService';
import SystemSettingsService from '../../api/SystemSettingsService';
import EHandleStatus from '../../enum/EHandleStatus';
import GLOBAL_VUE from '../../globalVue';
import RegexStr from '../../common/RegexStr';
import { numMulti } from '../../helper/calucate';
import { mapGetters } from 'vuex';
import AddDialog from './component/GoodAdd.vue';
import Header from './component/AddHeader.vue';
import addGoods from "../deliver/component/ReplaceGoods/AddGoods.vue";
var phoneRegex = new RegExp(RegexStr.mobile);
var initFormData = {
    order_sub_type: 3,
    order_time: moment().format('YYYY-MM-DD'),
    expect_arrivedate: '',
    delivery_order_id: '',
    supplier_to_business_id: '',
    business_id: '',
    business_name: '',
    organ_id: '',
    shop_id: '',
    shop_name: '',
    out_depot_id: '',
};
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.order_id = '';
        _this.handleStatus = EHandleStatus.Add;
        _this.formData = __assign({}, initFormData);
        _this.data = [];
        _this.selections = [];
        _this.supplierdepotOptions = [];
        _this.defaultDepotId = '';
        _this.defaultOutDepotName = '';
        _this.is_open_goods_replace = 2;
        return _this;
    }
    default_1.prototype.watchDeliveryOrderId = function (newValue, oldValue) {
        if (newValue && !this.order_id) {
            this.getDeliveryOrderDetail();
        }
    };
    default_1.prototype.watchOrganId = function (newValue, oldValue) {
        if (newValue && this.formData.order_sub_type === 4) {
            this.getSupplierdepotOptions();
        }
    };
    default_1.prototype.created = function () {
        this.OrderService = PurBackService.getInstance();
        this.deliverService = DeliverService.getInstance();
        this.purchaseService = PurchaseService.getInstance();
        this.systemService = SystemSettingsService.getInstance();
        if (this.order_id) {
            this.getDetail();
        }
        this.getSupplierConfigdetail();
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 370;
        }, 300);
    };
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.emptyGoods = function () {
        this.data = [];
    };
    default_1.prototype.resetAll = function () {
        this.formData = Object.assign({}, initFormData, { order_sub_type: this.formData.order_sub_type });
        this.data = [];
    };
    default_1.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data || {};
                _this.is_open_goods_replace = data.is_open_goods_replace || 2;
                _this.$store.commit(RootType.UPDATE_IS_ERP, data.is_erp);
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
        };
        this.purchaseService.getSupplierdepotOptions(params).then(function (res) {
            _this.supplierdepotOptions = res.data.data;
            (res.data.data || []).some(function (item) {
                if (item.is_organ_default == 1) {
                    _this.defaultDepotId = item.depot_id;
                    _this.defaultOutDepotName = item.depot_name;
                }
            });
        });
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (type === 'out_depot_id') {
            var index = this.supplierdepotOptions.findIndex(function (item) { return item.depot_id === row.out_depot_id; });
            row.out_depot_name = this.supplierdepotOptions[index].depot_name;
        }
        if (type === 'order_gift_amount') {
            if (row.order_gift_amount) {
                var giftAmountDecimal = row.order_gift_amount.toString().split('.');
                if ((giftAmountDecimal[1] && giftAmountDecimal[1].length > 3) || !giftAmountDecimal[1]) {
                    row.order_gift_amount = Math.floor(Math.abs(row.order_gift_amount) * 10000) / 10000;
                }
            }
        }
        if (type === 'order_detail_amount' || type === 'order_detail_uprice') {
            if (row.order_detail_amount > row.relate_order_detail_amount && this.formData.order_sub_type === 3) {
                row.order_detail_amount = row.relate_order_detail_amount;
            }
            if (row.order_detail_amount) {
                var amountDecimal = row.order_detail_amount.toString().split('.');
                if ((amountDecimal[1] && amountDecimal[1].length > 3) || !amountDecimal[1]) {
                    row.order_detail_amount = Math.floor(Math.abs(row.order_detail_amount) * 10000) / 10000;
                }
            }
            if (row.order_detail_uprice) {
                var upriceDecimal = row.order_detail_uprice.toString().split('.');
                if ((upriceDecimal[1] && upriceDecimal[1].length > 3) || !upriceDecimal[1]) {
                    row.order_detail_uprice = Math.floor(Math.abs(row.order_detail_uprice) * 10000) / 10000;
                }
            }
            if (row.order_detail_amount > 0 && row.order_detail_uprice > 0) {
                row.order_detail_money = new Number(_.multiply(row.order_detail_amount, row.order_detail_uprice)).toFixedNoZero(2);
                var order_detail_tax_rate = row.order_detail_tax_rate / 100;
                row.order_detail_tax_money =
                    Math.floor((row.order_detail_money / (1 + order_detail_tax_rate)) * order_detail_tax_rate * 10000) /
                        10000;
            }
            else {
                row.order_detail_money = '';
                row.order_detail_tax_money = '';
            }
        }
    };
    default_1.prototype.getDeliveryOrderDetail = function () {
        var _this = this;
        this.deliverService
            .getRefundDeliveryDetail({ delivery_order_id: this.formData.delivery_order_id })
            .then(function (res) {
            var data = res.data.data;
            _this.formData = Object.assign({}, _this.formData, {
                organ_name: data.organ_name,
                business_name: data.business_name,
                shop_name: data.shop_name,
                expect_arrivedate: data.expect_arrivedate,
                delivery_order_code: data.delivery_order_code,
                business_id: data.business_id,
                supplier_to_business_id: data.supplier_to_business_id,
                shop_id: data.shop_id,
                organ_id: data.organ_id,
            });
            var details = (data.details || []).map(function (item) {
                item.order_detail_uprice = item.relate_order_detail_uprice;
                return item;
            });
            _this.data = details;
            _this.data.forEach(function (item, index) {
                item.order_goods_replace && item.order_goods_replace.length !== 0 ? item.children.push(item.order_goods_replace) : '';
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
            console.log('data:%o', _this.data);
            console.log('formData:%o', _this.formData);
        });
    };
    default_1.prototype.save = function () {
        var _this = this;
        if (!this.checkSave())
            return;
        var params = __assign({}, this.formData, { data: JSON.stringify(this.data) });
        if (this.order_id) {
            params = Object.assign({}, params, { order_id: this.order_id });
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.OrderService.saveRejectOrder(params)
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改退货单', '保存', '保存']);
            }
            else {
                window._czc.push(['_trackEvent', '添加退货单', '保存', '保存']);
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.checkSave = function () {
        if (!this.canHandleGoods()) {
            return false;
        }
        var flag = true;
        if (this.data && this.data.length) {
            this.data.map(function (row) {
                if (!row.order_detail_amount) {
                    flag = false;
                }
            });
        }
        else {
            flag = false;
        }
        if (!flag) {
            this.$message.warning('货品信息不可为空，退货数量大于0，退货单价大于0。');
            return false;
        }
        return true;
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.order_id,
        };
        return this.OrderService.getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.formData = Object.assign({}, _this.formData, {
                supplier_to_business_id: data.supplier_to_business_id,
                order_sub_type: data.order_sub_type,
                order_time: data.order_time,
                expect_arrivedate: data.expect_arrivedate,
                delivery_order_id: data.delivery_order_id,
                delivery_order_code: data.delivery_order_code,
                business_name: data.customer,
                business_id: data.business_id,
                organ_id: data.organ_id,
                organ_name: data.organ_name,
                shop_id: data.shop_id,
                shop_name: data.shop_name,
                out_depot_id: data.out_depot_id,
                out_depot_name: data.out_depot_name,
                purchaser_name: data.purchaser_name,
                purchaser_phone: data.purchaser_phone,
                order_icomment: data.order_icomment,
            });
            var ITEMS = data.items.map(function (item) {
                item.goods_name = item.supplier_goods_name;
                item.goods_code = item.supplier_goods_code;
                item.goods_format_name = item.supplier_goods_format;
                item.unit_name = item.sales_unit_name;
                return item;
            });
            console.log('ITEMS', ITEMS);
            _this.data = ITEMS || [];
            _this.data.forEach(function (item, index) {
                item.order_goods_replace && item.order_goods_replace.length !== 0 ? item.children.push(item.order_goods_replace) : '';
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.toAddGood = function () {
        var _this = this;
        if (!this.canHandleGoods()) {
            return;
        }
        var width = 900;
        if (3 == this.formData.order_sub_type) {
            width = 1100;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                business_id: this.formData.business_id,
                supplier_to_business_id: this.formData.supplier_to_business_id,
                order_sub_type: this.formData.order_sub_type,
                delivery_order_id: this.formData.delivery_order_id,
            },
        }, {
            title: '添加货品',
            width: width,
            height: 550,
        });
        dialog.instance.$on('submit', function (res) {
            res.map(function (good, index) {
                if (4 == _this.formData.order_sub_type) {
                    good.out_depot_id = _this.defaultDepotId;
                    good.out_depot_name = _this.defaultOutDepotName;
                }
                good.order_detail_uprice = good.relate_order_detail_uprice;
                good.isIndex = true;
                good.parentIndex = index + 1;
                return good;
            });
            _this.data = res;
            console.log('toAddGood', _this.data);
            _this.selections = [];
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改退货单', '添加货品', '添加货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加退货单', '添加货品', '添加货品']);
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('删除的货品将无法重新添加到此单据，确认删除？', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改退货单', '删除货品', '删除货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加退货单', '删除货品', '删除货品']);
            }
        }, function (err) { });
    };
    default_1.prototype.canHandleGoods = function () {
        if (this.formData.order_sub_type === 3 && !this.formData.delivery_order_id) {
            this.$message.warning('请选择送货单');
            return false;
        }
        if (!this.formData.order_time) {
            this.$message.warning('请选择退货日期');
            return false;
        }
        if (this.formData.expect_arrivedate &&
            moment(this.formData.order_time).diff(moment(this.formData.expect_arrivedate)) < 0) {
            this.$message.warning('退货日期不能小于到货日期');
            return false;
        }
        if (this.formData.order_sub_type === 4 && !this.formData.supplier_to_business_id) {
            this.$message.warning('请选择客户');
            return false;
        }
        return true;
    };
    default_1.prototype.replaceGood = function (oldrow, index) {
        var _this = this;
        console.log(333, oldrow);
        var dialog = this.$dialog(addGoods, {
            data: {
                supplier_upper_id: 1,
                formData: this.formData,
                selectedGoodIds: [],
            },
        }, {
            title: "绑定替换货品",
            width: 950,
            height: 600,
            zIndex: 3000,
        });
        dialog.instance.$on("save:ok", function (row) {
            _this.$message.success('货品绑定成功！');
            console.log(index, 333);
            _this.data[index].children = row;
            _this.data[index].replace_supplier_goods_name = row[0].supplier_goods_name;
            _this.data[index].children[0].goods_name = row[0].supplier_goods_name;
            _this.data[index].children[0].goods_code = row[0].supplier_goods_code;
            _this.data[index].children[0].unit_name = row[0].sales_unit;
            _this.data[index].children[0].supplier_goods_format = row[0].goods_format_name;
            _this.data[index].children[0].order_detail_amount = oldrow.order_detail_amount;
            _this.data[index].children[0].outDepotOptions = oldrow.outDepotOptions;
            _this.data[index].children[0].order_detail_money = numMulti(oldrow.order_detail_amount, _this.data[index].children[0].order_detail_uprice);
            _this.data.forEach(function (item, index) {
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
            _this.$forceUpdate();
            _this.data[index].order_goods_replace_map = _this.data[index].children[0];
            console.log(555, _this.data);
        });
    };
    default_1.prototype.delReplaceGood = function (row, index) {
        console.log(row, index);
        this.$message.success('货品绑定删除成功');
        this.data[index - 1].children = [];
        this.data[index - 1].order_goods_replace_map = [];
        this.data[index - 1].replace_supplier_goods_name = '';
        this.$forceUpdate();
    };
    __decorate([
        Watch('formData.delivery_order_id')
    ], default_1.prototype, "watchDeliveryOrderId", null);
    __decorate([
        Watch('formData.organ_id', { immediate: true })
    ], default_1.prototype, "watchOrganId", null);
    default_1 = __decorate([
        Component({
            components: {
                'add-header': Header,
            },
            computed: __assign({}, mapGetters({
                isErp: 'isErp',
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
